(ns teamoesterreich.admin-mode.info.dsgvo
  (:require [clojure.string]
            [reagent.core :as r]
            [teamoesterreich.admin-mode.actions :as a]
            [reagent-material-ui.components :as mui]
            [teamoesterreich.setup :as setup]
            [teamoesterreich.firebase.remote-config :as remote-config]
            [teamoesterreich.util.log :as log]
            [teamoesterreich.view-state :as v-state]
            ))

(def setup setup/config)

(defn page []
  (let []
    [mui/grid
     {:container  true
      :direction  "row"
      :justify    "center"
      :alignItems "flex-start"
      :spacing    4
      :style      {:marginTop "25px"}
      }
     [mui/grid
      {:item true
       :xl   6                                              ;extra-large: 1920px
       :lg   6                                              ;large: 1280px
       :md   6                                              ;medium: 960px
       :sm   12                                             ;small: 600px
       :xs   12                                             ;extra-small: 0px
       }
      [mui/paper {:class ""
                  :style {:textAlign "left" :padding "25px"}}


       [:h1 "Datenschutz"]

       [:div

        [:h2 "Datenschutz"]
        [:div {:dangerouslySetInnerHTML {:__html (remote-config/get-string "privacy_policy_html")}}]


        [mui/button
         {:variant "contained"
          :style   {:margin "10px 0 10px 45px" :width "300px"}
          :onClick #(a/set-page-back :landing)
          }
         "Zurück"]
        [:br] [:br]

        ]

       ]
      ]
     ]
    ))


(defn get-it []
  (let [!st (atom {})]
    [page !st])
  )